/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import {
  Avatar,
  Grid,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "./somestyle.css";
import PopAddBasic from "./PopAddBasic";
import PopAddBasic1 from "./PopAddBasic1";
import MDLoading from "components/MDLoading/MDLoading";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Loader from "components/custom/Loader";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import useApiRequest from "utils/Apirequest";
import { convertUTCtoDubai } from "utils/Constant";
import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from '@mui/icons-material/Close';
import MDTypography from "components/MDTypography";
import { Padding, SafetyDivider } from "@mui/icons-material";
import { capitalizeFirstLetterSafe } from "utils";
import { Tag } from "antd";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Checkbox, Col, Divider, Row } from "antd";
import Typography from "@mui/material/Typography";

const services = [
  {
    name: "Charger Management",
    id: 1,
  },
  {
    name: "Driver Management",
    id: 9,
  },
  {
    name: "Vehicle Management",
    id: 13,
  },
  {
    name: "Location Management",
    id: 3,
  },
  {
    name: "RFID Card",
    id: 13,
  },
  {
    name: "Push Notifications",
    id: 5,
  },
  // {
  //   name: "Customer Service",
  //   id: 6,
  // },
  {
    name: "Analytics & Reports",
    id: 7,
  },
  {
    name: "Fault Management",
    id: 8,
  },
  {
    name: "Logs Management",
    id: 11,
  },
  {
    name: "Reservation",
    id: 12,
  },
  {
    name: "Bulk Upload Logs",
    id: 14,
  },
  {
    name: "Supervisor Management",
    id: 15,
  },
  {
    name: "Audit Logs",
    id: 15,
  },
  {
    name: "Vendor Performance",
    id: 16,
  }
];


function Admin() {
  const apiRequest = useApiRequest();
  const [activeTab, setActiveTab] = useState("ADMIN");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);


  const navigate = useNavigate();
  const getValues1 = () => {
    return {
      username: "",
      password: "",
      company: "",
      department: "",
    };
  };
  const getValues2 = () => {
    return {
      email: "",
      username: "",
      password: "",
      company: "",
      serviceID: [],
      department: "",
    };
  };

  const getValues3 = () => {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phoneNumber: "",
      password: "",
      locationId: ""
    };
  };


  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabled1, setIsDisabled1] = useState(false);
  const [columns, setColumns] = useState([]);
  const [values1] = useState(getValues1);
  const [values2] = useState(getValues2);
  const [isAdminTableLoading, setIsAdminTableLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  const [allUsers, setAllUsers] = useState([]);
  const [allUsersRowData, setAllUsersRowData] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [dialogEditData, setDialogEditData] = useState({
    _id: null,
    username: "",
    email: "",
    company: "",
    department: "",
    status: "",
    serviceID: [],
  });

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);



  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    const getData = async () => {

      const { data } =
        (await apiRequest(
          "get",
          `user-service-and-maintenance/admins-managers?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"}&search=${searchText}`,
          null,
          {},
        )) || {};

      if (data?.success === true) {
        const sortedRows = data?.data?.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRows(sortedRows);
        setTotalRows(data?.total);
        setIsAdminTableLoading(false);
      } else {
        setIsAdminTableLoading(false);
      }
    };
    getData();
  }, [page, pageSize, sorting, searchText]);



  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const handleSearchChange = (event) => {
    setSearchText(event);
    setPage(0);
  };

  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  const onDeleteClick = (rowData) => {
    setUserToDelete(rowData?.original);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    const userId = userToDelete?._id;

    try {
      const response = await apiRequest(
        "delete",
        `user-service-and-maintenance/admin/${userId}`,
        null,
        {}
      );

      if (response?.data?.success) {

        setDeleteDialogOpen(false);
        setUserToDelete(null);
        const { data } = await apiRequest(
          "get",
          `user-service-and-maintenance/admins-managers?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"}&search=${searchText}`,
          null,
          {},
          false,
          false
        );
        if (data?.success === true) {
          const sortedRows = data?.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setRows(sortedRows);
          setTotalRows(data?.total);
        }
      } else {
        enqueueSnackbar(response?.data?.message || "Error Deleting User!", { variant: "error" });
      }
    } catch (err) {
      enqueueSnackbar("Error Deleting User!", { variant: "error" });
      if (err?.response?.status === 401) {
        handleSignout();
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setUserToDelete(null);
  };

  const onCloseDialog = (e, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpenDialog(false);
  };

  const onEditClick = (rowData) => {
    const userData = rowData?.original;
    // Ensure serviceID is an array of numbers for checkbox matching
    const serviceIDs = userData?.serviceID ?
      (Array.isArray(userData.serviceID) ? userData.serviceID.map(id => Number(id)) : []) : [];

    setDialogEditData({
      _id: userData?._id,
      username: userData?.username || "",
      email: userData?.email || "",
      company: userData?.company || "",
      department: userData?.department || "",
      status: userData?.status || "Active",
      serviceID: serviceIDs,
      role: userData?.role || "Admin",
    });
    setOpenDialog(true);
  };

  console.log("Edit dialog", dialogEditData);

  const onServiceChange = (checkedValues) => {
    setDialogEditData((prevData) => ({
      ...prevData,
      serviceID: checkedValues,
    }));
  };

  const onUpdate = async () => {
    if (!dialogEditData.username || !dialogEditData.email) {
      enqueueSnackbar("Username and Email are required!", { variant: "error" });
      return;
    }

    setEditLoading(true);
    try {
      const response = await apiRequest(
        "put",
        `user-service-and-maintenance/admin/${dialogEditData._id}`,
        {
          username: dialogEditData.username,
          email: dialogEditData.email,
          company: dialogEditData.company,
          department: dialogEditData.department,
          status: dialogEditData.status,
          serviceID: dialogEditData.serviceID,
        },
        {}
      );

      if (response?.data?.success) {
        setOpenDialog(false);
        // Refresh the data
        const { data } = await apiRequest(
          "get",
          `user-service-and-maintenance/admins-managers?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"}&search=${searchText}`,
          null,
          {},
          false,
          false
        );
        if (data?.success === true) {
          const sortedRows = data?.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setRows(sortedRows);
          setTotalRows(data?.total);
        }
      } else {
        enqueueSnackbar(response?.data?.message || "Error Updating User!", { variant: "error" });
      }
    } catch (err) {
      enqueueSnackbar("Error Updating User!", { variant: "error" });
      if (err?.response?.status === 401) {
        handleSignout();
      }
    } finally {
      setEditLoading(false);
    }
  };

  const updateUserStatus = async (rowData, newStatus) => {
    try {
      await apiRequest(
        "patch",
        `user-service-and-maintenance/admin-manager/status/${rowData?.original?._id}`,
        {
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      setRows((prev) =>
        prev.map((row) =>
          row._id === rowData?.original?._id
            ? { ...row, status: newStatus }
            : row
        )
      );

    } catch (err) {
      console.error("Status update failed:", err);

      enqueueSnackbar(
        err?.response?.data?.message || "Failed to update status",
        { variant: "error" }
      );

      if (err?.response?.status === 401) {
        handleSignout();
      }
    }
  };

  const column = [
    {
      header: "Status",
      accessorKey: "status",
      size: 10,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },

      Cell: ({ row }) => {
        const status = row.original.status?.toLowerCase();

        const statusColors = {
          active: "green",
          inactive: "red",
        };

        return (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="md"
            sx={{ flex: 1 }}
          >
            <Tag color={statusColors[status] || "red"}>
              {capitalizeFirstLetterSafe(status)}
            </Tag>
          </MDBox>
        );
      },

    },

    {
      header: "Username",
      size: 10,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "username",
      align: "center",
    },
    {
      header: "Role",
      size: 10,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "role",
      align: "center",
    },
    {
      header: "Company",
      size: 10,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "company",
      align: "center",
    },
    {
      header: "Department",
      size: 10,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "department",
      align: "center",
    },
    {
      header: "Created At",
      size: 10,
      enableColumnFilter: false,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      accessorKey: "createdAt",
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
      align: "center",
    },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 100,
      align: "center",
      Cell: ({ row }) => {

        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => {
          setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
          setAnchorEl(null);
        };
        const handleAction = (action) => {
          action();
          handleClose();
        };

        const isActive = row.original.status?.toLowerCase() === "active";

        return (
          <>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                sx: {
                  py: 0.25,
                },
              }}
              PaperProps={{
                sx: {
                  minWidth: 210,
                  borderRadius: 1,
                },
              }}
            >
              {/* Edit User */}
              <MenuItem
                onClick={() => handleAction(() => onEditClick(row))}
                sx={{
                  py: 1,
                  px: 1.5,
                  gap: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 28,
                    color: "#8A8AAE",
                  }}
                >
                  <EditIcon fontSize="small" />
                </ListItemIcon>

                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#8A8AAE",
                  }}
                >
                  Edit User
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() =>
                  handleAction(() =>
                    updateUserStatus(row, isActive ? "Inactive" : "Active")
                  )
                }
                sx={{
                  py: 1,
                  px: 1.5,
                  gap: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 28,
                    color: isActive ? "#DC2626" : "#22C55E",
                  }}
                >
                  {isActive ? (
                    <BlockIcon fontSize="small" />
                  ) : (
                    <CheckCircleIcon fontSize="small" />
                  )}
                </ListItemIcon>

                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: isActive ? "#DC2626" : "#22C55E",
                  }}
                >
                  {isActive ? "Inactivate User" : "Activate User"}
                </Typography>
              </MenuItem>
            </Menu>

          </>
        );
      },
    }
  ];

  useEffect(() => {
    setColumns(column);
  }, []);





  const filteredRows = rows.filter((row) => {
    if (activeTab === "ADMIN") {
      return row.role === "Admin";
    }
    return row.role === "Manager";
  });

  return (
    <DashboardLayout>
      <PopAddBasic
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values1}
      />
      <PopAddBasic1
        isDialog={isDisabled1}
        onClose={setIsDisabled1}
        value={values2}
      />
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* <MDTypography
                    variant="h6"
                    color="white"
                    style={{ width: "50%" }}
                  >
                    All Admins and Managers
                  </MDTypography> */}
                  <MDBox
                    display="flex"
                    bgcolor="rgba(255,255,255,0.15)"
                    borderRadius="lg"
                  >
                    <MDButton
                      variant="text"
                      color="white"
                      onClick={() => setActiveTab("ADMIN")}
                      style={{
                        fontWeight: activeTab === "ADMIN" ? "bold" : "normal",
                        borderBottom: activeTab === "ADMIN" ? "2px solid white" : "none",
                      }}
                    >
                      ADMINS
                    </MDButton>

                    <MDButton
                      variant="text"
                      color="white"
                      onClick={() => setActiveTab("MANAGER")}
                      style={{
                        fontWeight: activeTab === "MANAGER" ? "bold" : "normal",
                        borderBottom: activeTab === "MANAGER" ? "2px solid white" : "none",
                      }}
                    >
                      MANAGERS
                    </MDButton>
                  </MDBox>
                  <MDBox
                    className="admin_btnsHeaderCont"
                    style={{
                      display: "flex",

                      justifyContent: "space-between",
                    }}
                  >
                    <MDButton
                      onClick={() => setIsDisabled1(!isDisabled1)}
                      variant="outlined"
                      color="white"
                      style={{ marginRight: "1rem" }}
                    >
                      Add Manager
                    </MDButton>
                    <MDButton
                      onClick={() => setIsDisabled(!isDisabled)}
                      variant="outlined"
                      color="white"
                    >
                      Add Admin
                    </MDButton>
                  </MDBox>
                </Grid>
              </MDBox>
              {isAdminTableLoading ? (
                <Loader />
              ) : (

                <CustomMaterialTablePage
                  columns={columns}
                  data={filteredRows}
                  darkMode={darkMode}
                  manualPagination={true}
                  manualFiltering={false}
                  rowCount={totalRows}
                  paginationChange={(newPage) => setPagination(newPage)}
                  soringChange={handleSortingChange}
                  page={page}
                  pagesize={pageSize}
                  paginataion={pagination}
                  sorting={sorting}
                  searchText={searchText}
                  searchChange={handleSearchChange}
                  onColumnFiltersChange={setColumnFilters}
                  onColumnVisibilityChange={setColumnVisibility}
                  state={{
                    pagination,
                    sorting,
                    columnFilters,
                    columnVisibility,
                  }}
                  globalFilterDebounceMs={2000}
                />
              )}

            </Card>
          </Grid>
        </Grid>
      </MDBox>


      <MDLoading open={deleteLoading} />

      <Dialog
        fullWidth
        maxWidth="sm"
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
      >

        <DialogTitle
          sx={{
            px: 4,
            py: 3,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            backgroundColor: darkMode ? "#202940" : "inherit",
            color: darkMode ? "#fff" : "inherit",
          }}
        >
          <MDTypography variant="h5" color="inherit">
            ⚠️ Confirm Delete
          </MDTypography>
        </DialogTitle>


        <DialogContent
          sx={{
            px: 4,
            py: 3,
            backgroundColor: darkMode ? "#202940" : "inherit",
            color: darkMode ? "#fff" : "inherit",
          }}
        >
          <MDBox py={2}>
            <MDTypography variant="body1" mb={2}>
              Are you sure you want to delete this user?
            </MDTypography>

            {userToDelete && (
              <Card
                sx={{
                  backgroundColor: darkMode ? "#1a2035" : "#f5f5f5",
                  borderRadius: "0.75rem",
                  border: "1px solid",
                  borderColor: darkMode ? "#2c3450" : "#e0e0e0",
                  p: 2,
                }}
              >
                <MDTypography variant="body2">
                  <strong>Username:</strong> {userToDelete.username}
                </MDTypography>
                <MDTypography variant="body2">
                  <strong>Email:</strong> {userToDelete.email}
                </MDTypography>
                <MDTypography variant="body2">
                  <strong>Role:</strong> {userToDelete.role}
                </MDTypography>
                <MDTypography variant="body2">
                  <strong>Company:</strong> {userToDelete.company}
                </MDTypography>
              </Card>
            )}

            <MDTypography
              variant="caption"
              color="error"
              mt={2}
              display="block"
            >
              This action cannot be undone.
            </MDTypography>
          </MDBox>
        </DialogContent>

        <DialogActions
          sx={{
            px: 4,
            py: 3,
            backgroundColor: darkMode ? "#202940" : "inherit",
            justifyContent: "space-between",
          }}
        >
          <MDButton
            variant="outlined"
            color="dark"
            onClick={handleDeleteCancel}
            disabled={deleteLoading}
          >
            Cancel
          </MDButton>

          <MDButton
            variant="gradient"
            color="error"
            onClick={handleDeleteConfirm}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Deleting..." : "Delete"}
          </MDButton>
        </DialogActions>
      </Dialog>


      <Dialog open={openDialog} onClose={onCloseDialog} fullWidth maxWidth="md">

        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#202940" : "inherit",
            color: darkMode ? "#ffffff" : "inherit",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {activeTab === "ADMIN" ? "Update Admin" : "Update Manager"}
          <IconButton onClick={onCloseDialog} sx={{ color: darkMode ? "#fff" : "inherit" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            backgroundColor: darkMode ? "#202940" : "inherit",
            color: darkMode ? "#ffffff" : "inherit",
          }}
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox p={1} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Username"
                  fullWidth
                  value={dialogEditData.username}
                  onChange={(e) =>
                    setDialogEditData({ ...dialogEditData, username: e.target.value })
                  }
                />
              </MDBox>

              <MDBox p={1}>
                <MDInput
                  type="email"
                  label="Email"
                  fullWidth
                  value={dialogEditData.email}
                  onChange={(e) =>
                    setDialogEditData({ ...dialogEditData, email: e.target.value })
                  }
                />
              </MDBox>

              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel>Company</InputLabel>
                  <Select
                    sx={{ height: 50 }}
                    value={dialogEditData.company}
                    onChange={(e) =>
                      setDialogEditData({ ...dialogEditData, company: e.target.value })
                    }
                    input={<OutlinedInput label="Company" />}
                  >
                    <MenuItem value="DTC">DTC</MenuItem>
                    <MenuItem value="Presight">Presight</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel>Department</InputLabel>
                  <Select
                    sx={{ height: 50 }}
                    value={dialogEditData.department}
                    onChange={(e) =>
                      setDialogEditData({
                        ...dialogEditData,
                        department: e.target.value,
                      })
                    }
                    input={<OutlinedInput label="Department" />}
                  >
                    <MenuItem value="IT & Support">IT & Support</MenuItem>
                    <MenuItem value="Human Resources">Human Resources</MenuItem>
                    <MenuItem value="Finance & Accounting">Finance & Accounting</MenuItem>
                    <MenuItem value="Operations">Operations</MenuItem>
                    <MenuItem value="Sales & Marketing">Sales & Marketing</MenuItem>
                    <MenuItem value="Product Management">Product Management</MenuItem>
                    <MenuItem value="Engineering & Development">
                      Engineering & Development
                    </MenuItem>
                    <MenuItem value="Quality Assurance">Quality Assurance</MenuItem>
                    <MenuItem value="Legal & Compliance">Legal & Compliance</MenuItem>
                    <MenuItem value="Procurement & Vendor Management">
                      Procurement & Vendor Management
                    </MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    sx={{ height: 50 }}
                    value={dialogEditData.status}
                    onChange={(e) =>
                      setDialogEditData({ ...dialogEditData, status: e.target.value })
                    }
                    input={<OutlinedInput label="Status" />}
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              {dialogEditData?.role === "Manager" && (
                <MDBox p={1}>
                  <FormLabel>Services</FormLabel>
                  <Checkbox.Group
                    style={{ width: "100%", marginTop: "0.5rem" }}
                    value={dialogEditData.serviceID}
                    onChange={onServiceChange}
                  >
                    <Row gutter={[16, 16]}>
                      {services.map((service) => (
                        <Col key={service.id} xs={24} sm={12} md={8}>
                          <Checkbox value={service.id}>{service.name}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </MDBox>
              )}
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: darkMode ? "#202940" : "inherit",
            justifyContent: "space-evenly",
          }}
        >
          <MDButton
            variant="gradient"
            color={sidenavColor}
            onClick={onCloseDialog}
            disabled={editLoading}
          >
            Close
          </MDButton>

          <MDButton
            variant="gradient"
            color={sidenavColor}
            onClick={onUpdate}
            disabled={editLoading}
          >
            {editLoading ? "Updating..." : "Update"}
          </MDButton>
        </DialogActions>
      </Dialog>

    </DashboardLayout>
  );
}

export default Admin;
